<header class="site-header">
  <!-- MOBILE TOP BAR -->
  <div class="mobile-top-bar">
    <div class="mobile-menu-btn" (click)="toggleMobileMenu()">
      <mat-icon>menu</mat-icon>
    </div>
    
    <div class="mobile-logo" routerLink="/affiliate">
      <img src="assets/img/logo-a1102.svg" alt="1NO2 Affiliate" />
    </div>
    
    <div class="mobile-right">
      <!-- Empty space to balance flex -->
    </div>
  </div>

  <!-- DESKTOP SIDEBAR -->
  <div class="desktop-sidebar">
    <div class="sidebar-logo">
      <img routerLink="/affiliate" src="assets/img/logo-a1102.svg" alt="1NO2 Affiliate" />
    </div>

    <nav class="sidebar-nav">
      <a routerLink="/affiliate" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-item">
        <mat-icon>dashboard</mat-icon> <span>{{ 'AFFILIATE.HEADER.OVERVIEW' | translate }}</span>
      </a>

      <!-- Tools for Active Affiliates -->
      <ng-container *ngIf="(authService.isLoggedIn() | async) && isAffiliate">
        <a routerLink="/affiliate/campaigns" routerLinkActive="active" class="nav-item">
          <mat-icon>campaign</mat-icon> <span>{{ 'AFFILIATE.HEADER.CAMPAIGNS' | translate }}</span>
        </a>
        <a routerLink="/affiliate/links" routerLinkActive="active" class="nav-item">
          <mat-icon>link</mat-icon> <span>{{ 'AFFILIATE.HEADER.MANAGE_LINKS' | translate }}</span>
        </a>
        <a routerLink="/affiliate/finance" routerLinkActive="active" class="nav-item">
          <mat-icon>account_balance_wallet</mat-icon> <span>{{ 'AFFILIATE.HEADER.FINANCE' | translate }}</span>
        </a>
        <a routerLink="/affiliate/history" routerLinkActive="active" class="nav-item">
          <mat-icon>history</mat-icon> <span>{{ 'AFFILIATE.HEADER.HISTORY' | translate }}</span>
        </a>
        <a routerLink="/affiliate/payment-settings" routerLinkActive="active" class="nav-item">
          <mat-icon>settings</mat-icon> <span>{{ 'AFFILIATE.HEADER.PAYMENT_SETTINGS' | translate }}</span>
        </a>
      </ng-container>

      <!-- Public Program Info for everyone -->
      <a routerLink="/affiliate/program-info" routerLinkActive="active" class="nav-item">
        <mat-icon>info</mat-icon> <span>{{ 'AFFILIATE.HEADER.PROGRAM_INFO' | translate }}</span>
      </a>
    </nav>

    <div class="sidebar-footer" *ngIf="authService.isLoggedIn() | async">
      <div class="user-info-inline">
        <div class="user-info-left" [matMenuTriggerFor]="userMenu" style="cursor: pointer;" title="Tùy chọn tài khoản">
          <div class="user-avatar"><mat-icon>person</mat-icon></div>
          <div class="user-name">{{ 'AFFILIATE.HEADER.HELLO' | translate }},<br><strong>{{ personalData?.firstName || personalData?.userName || ('AFFILIATE.HEADER.PARTNER' | translate) }}</strong></div>
        </div>
        
        <div class="inline-actions" style="display: flex; gap: 8px;">
          <button class="btn-action-inline" (click)="logout()" title="Đăng xuất">
            <mat-icon>logout</mat-icon>
          </button>
        </div>

        <!-- User Menu -->
        <mat-menu #userMenu="matMenu" class="custom-dark-menu">
          <button mat-menu-item routerLink="/profiles">
            <mat-icon style="color: #4b5563;">person</mat-icon>
            <span style="color: #374151;">{{ 'AFFILIATE.HEADER.PERSONAL_INFO' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openCancelModal()" [disabled]="isPendingCancellation">
            <mat-icon [style.color]="isPendingCancellation ? '#9ca3af' : '#ef4444'">cancel</mat-icon>
            <span [style.color]="isPendingCancellation ? '#9ca3af' : '#ef4444'">{{ 'AFFILIATE.HEADER.CANCEL_REGISTRATION' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
    
    <div class="sidebar-footer logged-out" *ngIf="!(authService.isLoggedIn() | async)">
       <a routerLink="/auth/login" class="btn-login">{{ 'AFFILIATE.HEADER.LOGIN' | translate }}</a>
       <a routerLink="/auth/register" class="btn-register">{{ 'AFFILIATE.HEADER.REGISTER' | translate }}</a>
    </div>
  </div>
</header>

<div
  class="mobile-menu-overlay"
  *ngIf="mobileMenuOpen"
  (click)="toggleMobileMenu()"
>
  <div class="mobile-menu open" (click)="$event.stopPropagation()">
    <div class="mobile-menu-header">
      <div class="user-greeting">
        <div class="avatar-placeholder">
          <mat-icon>person</mat-icon>
        </div>
        <div class="greeting-text">
          <span class="hello-text">{{ 'AFFILIATE.HEADER.HELLO' | translate }},</span>
          <span class="user-name">{{ personalData?.firstName || personalData?.userName || ('AFFILIATE.HEADER.PARTNER' | translate) }}</span>
        </div>
      </div>
      <mat-icon (click)="toggleMobileMenu()" class="close-btn">close</mat-icon>
    </div>

    <div class="mobile-user-section">
      <div class="mobile-quick-actions">
        <div class="action-item" routerLink="/affiliate" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="active" (click)="closeMenu()">
          <mat-icon>dashboard</mat-icon>
          <span>{{ 'AFFILIATE.HEADER.OVERVIEW' | translate }}</span>
        </div>

        <ng-container *ngIf="(authService.isLoggedIn() | async) && isAffiliate">
          <div class="action-item" routerLink="/affiliate/campaigns" routerLinkActive="active" (click)="closeMenu()">
            <mat-icon>campaign</mat-icon>
            <span>{{ 'AFFILIATE.HEADER.CAMPAIGNS' | translate }}</span>
          </div>
          <div class="action-item" routerLink="/affiliate/links" routerLinkActive="active" (click)="closeMenu()">
            <mat-icon>link</mat-icon>
            <span>{{ 'AFFILIATE.HEADER.MANAGE_LINKS' | translate }}</span>
          </div>
          <div class="action-item" routerLink="/affiliate/finance" routerLinkActive="active" (click)="closeMenu()">
            <mat-icon>account_balance_wallet</mat-icon>
            <span>{{ 'AFFILIATE.HEADER.FINANCE' | translate }}</span>
          </div>
          <a class="action-item" routerLink="/affiliate/history" routerLinkActive="active" (click)="closeMenu()">
            <mat-icon>history</mat-icon>
            <span>{{ 'AFFILIATE.HEADER.HISTORY' | translate }}</span>
          </a>
          <div class="action-item" routerLink="/affiliate/payment-settings" routerLinkActive="active" (click)="closeMenu()">
            <mat-icon>settings</mat-icon>
            <span>{{ 'AFFILIATE.HEADER.PAYMENT_SETTINGS' | translate }}</span>
          </div>
        </ng-container>

        <div class="action-item" routerLink="/affiliate/program-info" routerLinkActive="active" (click)="closeMenu()">
          <mat-icon>info</mat-icon>
          <span>{{ 'AFFILIATE.HEADER.PROGRAM_INFO' | translate }}</span>
        </div>
      </div>
      
      <div class="mobile-logout-section" *ngIf="authService.isLoggedIn() | async" style="border-top: 1px solid #eee; margin-top: 15px; padding-top: 15px;">
        <div class="action-item" (click)="openCancelModal(); closeMenu()" [style.color]="isPendingCancellation ? '#9ca3af' : '#ef4444'" style="padding: 10px 15px; display: flex; align-items: center; gap: 10px;">
          <mat-icon [style.color]="isPendingCancellation ? '#9ca3af' : '#ef4444'">cancel</mat-icon>
          <span>{{ 'AFFILIATE.HEADER.CANCEL_REGISTRATION' | translate }}</span>
        </div>
        <div class="action-item logout" (click)="logout(); closeMenu()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'AFFILIATE.HEADER.LOGOUT' | translate }}</span>
        </div>
      </div>

      <div class="mobile-logout-section" *ngIf="!(authService.isLoggedIn() | async)" style="border-top: 1px solid #eee; margin-top: 15px; padding-top: 15px; display: flex; gap: 10px; padding: 15px;">
        <a routerLink="/auth/login" (click)="closeMenu()" class="btn-login" style="flex: 1; text-align: center; padding: 10px; background: #FF9800; color: #111; font-weight: 700; border-radius: 8px; text-decoration: none;">{{ 'AFFILIATE.HEADER.LOGIN' | translate }}</a>
        <a routerLink="/auth/register" (click)="closeMenu()" class="btn-register" style="flex: 1; text-align: center; padding: 10px; background: rgba(255,255,255,0.1); color: #fff; font-weight: 600; border-radius: 8px; text-decoration: none;">{{ 'AFFILIATE.HEADER.REGISTER' | translate }}</a>
      </div>
    </div>
  </div>
</div>

<!-- Cancel Confirmation Modal -->
<div class="aff-modal-overlay" *ngIf="isCancelModalVisible" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;">
  <div class="aff-modal-content" style="background: white; border-radius: 8px; padding: 24px; width: 90%; max-width: 400px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
    <div class="aff-modal-header" style="margin-bottom: 15px;">
      <h3 style="margin: 0; font-size: 18px; color: #1f2937;">{{ 'AFFILIATE.HEADER.CANCEL_MODAL.TITLE' | translate }}</h3>
    </div>
    <div class="aff-modal-body" style="padding: 10px 0 20px; color: #4b5563; font-size: 15px;">
      {{ 'AFFILIATE.HEADER.CANCEL_MODAL.MESSAGE' | translate }}<br>
      <span style="font-size: 13px; color: #9ca3af; margin-top: 8px; display: inline-block;">
        {{ 'AFFILIATE.HEADER.CANCEL_MODAL.HINT' | translate }}
      </span>
    </div>
    <div class="aff-modal-footer" style="display: flex; justify-content: flex-end; gap: 12px; margin-top: 10px;">
      <button class="aff-action-btn" style="padding: 8px 16px; border: 1px solid #d1d5db; background: white; border-radius: 6px; cursor: pointer;" (click)="closeCancelModal()">{{ 'AFFILIATE.HEADER.CANCEL_MODAL.CANCEL_BTN' | translate }}</button>
      <button class="aff-btn-primary" style="padding: 8px 16px; background: #ef4444; color: white; border: none; border-radius: 6px; cursor: pointer; min-width: auto;" (click)="executeCancel()" [disabled]="isCanceling">
        {{ isCanceling ? ('AFFILIATE.HEADER.CANCEL_MODAL.CANCELING_BTN' | translate) : ('AFFILIATE.HEADER.CANCEL_MODAL.CONFIRM_BTN' | translate) }}
      </button>
    </div>
  </div>
</div>
